<template>
  <div id="printTest" style="margin: 10%">
    <el-card>
      <div style="text-align: right">
        <el-button type="primary" size="small" v-print="'#printTest'">Print</el-button>
      </div>
      <div style="display: flex">
        <div style="flex: 1">
          <div style="width: 100%">
            <img style="width: 100%;" src="../../assets/spclogo.png" alt="">
          </div>
        </div>
        <div style="flex: 6">
          <h1 style="text-align: center;font-weight: bold;font-size: 30px">Sourcing Perfume & Cosmetic (SH) Ltd.
            QA Report</h1>
          <p style="text-align: center;font-size: 20px">QA REPORT NO: {{this.qaReportList[0].id}}</p>
        </div>
      </div>
      <!--      <div style="width: 10%">-->
      <!--        <img style="width: 100%;" src="../../assets/spclogo.png" alt="">-->
      <!--      </div>-->
      <!--      <h1 style="text-align: left;font-size: 20px">REPORT NO: 1</h1>-->
      <!--      <h1 style="text-align: center;font-weight: bold;font-size: 30px">Sourcing Perfume & Cosmetic (SH) Ltd.-->
      <!--        QA Repor</h1>-->
      <br><br><br>
      <div></div>
      <!--      <el-descriptions class="margin-top" title="" :column="2" :size="size" border>-->
      <div class="aa">
        <div class="bb">Customer客户:</div>
        <div class="cc">{{this.qaReportList[0].bp}}</div>
        <div class="bb">Type Of Product 产品类别:</div>
        <div class="cc">{{this.qaReportList[0].proType}}</div>
      </div>
      <div class="aa">
        <div class="bb">Brand 品牌:</div>
        <div class="cc">{{this.qaReportList[0].brand}}</div>
        <div class="bb">Supplier供应商:</div>
        <div class="cc">{{this.qaReportList[0].supplier}}</div>
      </div>
      <div class="aa">
        <div class="bb">Material 材料:</div>
        <div class="cc">{{this.qaReportList[0].material}}</div>
        <div class="bb">Drawing No.图纸编号:</div>
        <div class="cc">{{this.qaReportList[0].drawingNo}}</div>
      </div>
      <div class="aa">
        <div class="bb">report date 报告日期:</div>
        <div class="cc">{{this.qaReportList[0].reportDate}}</div>
        <div class="bb">Checked by 测试人:</div>
        <div class="cc">{{this.qaReportList[0].checkedBy}}</div>
      </div>
      <div class="aa">
        <div class="bb">Sample Disc 样品描述:</div>
        <div class="cc">{{this.qaReportList[0].sampleDisc}}</div>
        <div class="bb">Project Name 项目名称:</div>
        <div class="cc">{{this.qaReportList[0].projectName}}</div>
      </div>
<!--      <div class="aa">-->
<!--        <div class="bb">Results:</div>-->
<!--        <div class="cc">-->
<!--          <el-radio v-model="this.qaReportList[0].conclusion" label="0">Accept</el-radio>-->
<!--          <el-radio v-model="this.qaReportList[0].conclusion" label="1">Reject</el-radio>-->
<!--          <el-radio v-model="this.qaReportList[0].conclusion" label="3">Pending</el-radio>-->
<!--        </div>-->
<!--        <div class="bb">Improve:</div>-->
<!--        <div class="cc">-->
<!--          {{this.qaReportList[0].improve}}-->
<!--        </div>-->
<!--      </div>-->
      <div class="aa">
        <div class="bb">Results:</div>
        <div class="cc" style="flex: 5;padding: 12px 30px;padding-bottom: 12px;">
          <el-checkbox :true-label="'0'" disabled v-model="this.qaReportList[0].conclusion" label="0">Accept</el-checkbox>
          <el-checkbox :true-label="'1'" disabled v-model="this.qaReportList[0].conclusion" label="1">Reject</el-checkbox>
          <el-checkbox :true-label="'3'" disabled v-model="this.qaReportList[0].conclusion" label="3">Pending</el-checkbox>
        </div>
      </div>
      <div class="aa">
        <div class="bb">Remark:</div>
        <div class="cc" style="flex: 5;padding: 12px 30px;padding-bottom: 12px;">
          {{this.qaReportList[0].remark}}
        </div>
      </div>
      <div class="aa">
        <div class="bb">Dev Comments:</div>
        <div class="cc" style="flex: 5;padding: 12px 30px;padding-bottom: 12px;">
          {{this.qaReportList[0].devComments}}
        </div>
      </div>
      <div class="aa">
        <div class="bb">Dev Improve:</div>
        <div class="cc" style="flex: 5;padding: 12px 30px;padding-bottom: 12px;">
          {{this.qaReportList[0].improve}}
        </div>
      </div>
      <br>
      <p>Images:</p>
      <div style="border: 1px solid #EBEEF5">
        <el-image style="margin: 5px;padding: 5px;height: 250px;border: 1px solid #EBEEF5" v-for="url in this.qaReportList[0].imgs" :key="url" :src="url" @click="clickImg(url)"></el-image>
      </div>
      <br>
      <p>General appearance of the Samples:</p>
      <div class="aa">
        <div class="bb">
          <p>Coherent color range of the sample submitted</p>
          <p>颜色一致性</p>
        </div>
        <div class="cc">
          <el-checkbox :true-label="'0'" disabled v-model="this.qaReportList[0].color" label="0">OK</el-checkbox>
          <el-checkbox :true-label="'1'" disabled v-model="this.qaReportList[0].color" label="1">NG</el-checkbox>
        </div>
        <div class="bb">
          <p>Remark</p>
          <p>备注</p>
        </div>
        <div class="cc">{{this.qaReportList[0].colorRemark}}</div>
      </div>

      <div class="aa">
        <div class="bb">
          <p>Scratch on the surface</p>
          <p>表面擦伤</p>
        </div>
        <div class="cc">
          <el-checkbox :true-label="'0'" disabled v-model="this.qaReportList[0].scratch" label="0">OK</el-checkbox>
          <el-checkbox :true-label="'1'" disabled v-model="this.qaReportList[0].scratch" label="1">NG</el-checkbox>
        </div>
        <div class="bb">
          <p>Remark</p>
          <p>备注</p>
        </div>
        <div class="cc">{{this.qaReportList[0].scratchRemark}}</div>
      </div>

      <div class="aa">
        <div class="bb">
          <p>Dot on the metalization or electroplating</p>
          <p>表面杂点</p>
        </div>
        <div class="cc">
          <el-checkbox :true-label="'0'" disabled v-model="this.qaReportList[0].metalization" label="0">OK</el-checkbox>
          <el-checkbox :true-label="'1'" disabled v-model="this.qaReportList[0].metalization" label="1">NG</el-checkbox>
        </div>
        <div class="bb">
          <p>Remark</p>
          <p>备注</p>
        </div>
        <div class="cc">{{this.qaReportList[0].metalizationRemark}}</div>
      </div>

      <div class="aa">
        <div class="bb">
          <p>General cleanliness of the samples submitted</p>
          <p>表面清洁度</p>
        </div>
        <div class="cc">
          <el-checkbox :true-label="'0'" disabled v-model="this.qaReportList[0].cleanliness" label="0">OK</el-checkbox>
          <el-checkbox :true-label="'1'" disabled v-model="this.qaReportList[0].cleanliness" label="1">NG</el-checkbox>
        </div>
        <div class="bb">
          <p>Remark</p>
          <p>备注</p>
        </div>
        <div class="cc">{{this.qaReportList[0].cleanlinessRemark}}</div>
      </div>

      <div class="aa">
        <div class="bb">
          <p>Other appearance defects</p>
          <p>其他外观缺陷</p>
        </div>
        <div class="cc">
          <el-checkbox :true-label="'0'" disabled v-model="this.qaReportList[0].other" label="0">OK</el-checkbox>
          <el-checkbox :true-label="'1'" disabled v-model="this.qaReportList[0].other" label="1">NG</el-checkbox>
        </div>
        <div class="bb">
          <p>Remark</p>
          <p>备注</p>
        </div>
        <div class="cc">{{this.qaReportList[0].otherRemark}}</div>
      </div>
      <p>Test Data:</p>
      <el-table :span-method="objectSpanMethod" :data="qaTestList" border stripe style="width: 100%">
        <el-table-column
          prop="categoryName"
          label="Category Name" sortable
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="testConclusion"
          label="Conclusion"
          min-width="100">
          <template slot-scope="scope">
            <p v-if="scope.row.testConclusion === '1'">OK</p>
            <p v-else>NG</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="testResult"
          label="Result"
          min-width="80">
          <template slot-scope="scope">
            <p v-if="scope.row.testResult === '1'">OK</p>
            <p v-else>NG</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="perResult"
          label="Per Result"
          min-width="80">
          <template slot-scope="scope">
            <p v-if="scope.row.perResult === '1'">OK</p>
            <p v-else>NG</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="remarkName"
          label="Remark Name"
          width="100">
        </el-table-column>
        <el-table-column
          prop="valuev"
          label="Value"
          width="80">
          <template slot-scope="scope">
              <span v-if="scope.row.categoryType === '0'">
                <p>{{scope.row.valuev}}</p>
              </span>
              <span v-if="scope.row.categoryType === '1'">
                <p v-if="scope.row.valuev === '1'">OK</p>
                <p v-else>NG</p>
              </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="minv"
          label="Min"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="avgv"
          label="Avg"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="maxv"
          label="Max"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="lcl"
          label="LCL"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="std"
          label="STD"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="ucl"
          label="UCL"
          min-width="80">
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import Print from 'vue-print-nb'
import axios from 'axios'
Vue.use(Print)
export default {
  name: 'QAReportDetail',
  data () {
    return {
      qaTestList: [],
      uploadImgUrl: axios.defaults.baseURL + '/file/upload/img/',
      qaReportList: [],
      formInline: {
        projectName: '',
        pageNo: 1,
        pageSize: 100
      }
    }
  },
  created () {
    this.formInline = this.$route.query
    this.formInline.id = this.formInline.qaReportId
    this.getList()
    this.getTestList()
  },
  methods: {
    clickImg (x) {
      window.open(x, '_blank')
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 0 || columnIndex === 6 || columnIndex === 7 || columnIndex === 8 || columnIndex === 9 || columnIndex === 10 || columnIndex === 11) {
      //   if (rowIndex % 2 === 0) {
      //     return {
      //       rowspan: 2,
      //       colspan: 1
      //     }
      //   } else {
      //     return {
      //       rowspan: 0,
      //       colspan: 0
      //     }
      //   }
      // }
      // if (columnIndex === 6) {
      //   if (rowIndex % 2 === 0) {
      //     return {
      //       rowspan: 2,
      //       colspan: 1
      //     }
      //   } else {
      //     return {
      //       rowspan: 0,
      //       colspan: 0
      //     }
      //   }
      // }
    },
    async getTestList () {
      const { data: ress } = await this.$http.get('/QATest/list?reportId=' + this.$route.query.qaReportId)
      this.qaTestList = ress.result.records
      // console.log(this.qaTestList)
    },
    async getList () {
      const { data: res } = await this.$http.get('/qaReport/list', { params: this.formInline })
      this.qaReportList = res.result.records
      // console.log(this.qaReportList[0])
      const listv = res.result.records[0].imgs.split(',')
      this.qaReportList[0].imgs = listv
    }
  }
}
</script>

<style scoped>
.aa {display: flex;font-size: 14px}
.bb {color: #909399;
  background: #fafafa;
  flex: 1;border: 1px solid #EBEEF5;
  padding: 12px 10px;padding-bottom: 12px;
}
.cc {flex: 2;border: 1px solid #EBEEF5;
  padding: 12px 10px;padding-bottom: 12px;
}
</style>
